/* Noble Designs: media sections helpers (ported from Symmetry 5.6 inline scripts) */
(() => {
  if (window.customElements.get('nd-media-gallery')) return;

  /**
   * Gallery: on desktop, give every overlay text box in the gallery the height of the tallest one,
   * so titles/buttons line up across images (5.6 gallery inline script).
   */
  class NdMediaGallery extends HTMLElement {
    connectedCallback() {
      this.mql = window.matchMedia('(min-width: 768px)');
      this.equalize = this.equalize.bind(this);
      this.onResize = () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(this.equalize, 150);
      };
      window.addEventListener('resize', this.onResize);
      if (document.readyState === 'complete') {
        this.equalize();
      } else {
        window.addEventListener('load', this.equalize, { once: true });
        this.equalize();
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      window.removeEventListener('load', this.equalize);
    }

    equalize() {
      const texts = this.querySelectorAll('.text-overlay__text');
      texts.forEach((el) => { el.style.minHeight = ''; });
      if (!this.mql.matches || texts.length < 2) return;
      let max = 0;
      texts.forEach((el) => { max = Math.max(max, el.offsetHeight); });
      texts.forEach((el) => { el.style.minHeight = `${max}px`; });
    }
  }

  window.customElements.define('nd-media-gallery', NdMediaGallery);
})();
